import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoPagoUnicoCATA = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoPagoUnicoCATA = () => {
  const [loadingGetInfoPagoUnicoCATA, setLoadingGetInfoPagoUnicoCATA] = useState(false);
  const [successGetInfoPagoUnicoCATA, setSuccessGetInfoPagoUnicoCATA] = useState(false);
  const [errorGetInfoPagoUnicoCATA, setErrorGetInfoPagoUnicoCATA] = useState<any>(null);
  const [dataGetInfoPagoUnicoCATA, setDataGetInfoPagoUnicoCATA] = useState<any>(null);

  const [statusGetInfoPagoUnicoCATA, setStatusGetInfoPagoUnicoCATA] =
    useState<StatusGetInfoPagoUnicoCATA>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoPagoUnicoCATA = async (
    userId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoPagoUnicoCATA(true);
    setSuccessGetInfoPagoUnicoCATA(false);
    setErrorGetInfoPagoUnicoCATA(null);

    try {
      const res = await apiRecord.getInfoSolicitudPagoUnico(userId);

      setStatusGetInfoPagoUnicoCATA({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetInfoPagoUnicoCATA(true);
      setDataGetInfoPagoUnicoCATA(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetInfoPagoUnicoCATA({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetInfoPagoUnicoCATA(err);
      console.error("Error en getInfoPagoUnicoCATA:", err);

      throw err;

    } finally {
      setLoadingGetInfoPagoUnicoCATA(false);
    }
  };

  return {
    getInfoPagoUnicoCATA,
    loadingGetInfoPagoUnicoCATA,
    successGetInfoPagoUnicoCATA,
    errorGetInfoPagoUnicoCATA,
    dataGetInfoPagoUnicoCATA,
    statusGetInfoPagoUnicoCATA
  };
};

export default useGetInfoPagoUnicoCATA;
